import { render } from "./GroupsViewer.vue?vue&type=template&id=78bc9ceb"
import script from "./GroupsViewer.vue?vue&type=script&lang=js"
export * from "./GroupsViewer.vue?vue&type=script&lang=js"

import "./GroupsViewer.vue?vue&type=style&index=0&id=78bc9ceb&lang=scss"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__